const ITEMS = [
    "Édition limitée Spider-Web 2026",
    "Livraison offerte dès 50 €",
    "Pins Jibbitz inclus",
    "Paiement sécurisé",
    "2 paires exclusives",
];

const Row = ({ ariaHidden = false }) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
        {ITEMS.map((item, i) => (
            <span key={`${item}-${i}`} className="flex items-center">
                <span className="font-display uppercase text-2xl sm:text-3xl tracking-wide text-zinc-700 px-6">
                    {item}
                </span>
                <span className="w-2.5 h-2.5 rounded-full bg-spidey-red glow-red shrink-0" />
            </span>
        ))}
    </div>
);

export default function Marquee() {
    return (
        <div className="relative border-y border-zinc-900 bg-spidey-panel/60 py-5 overflow-hidden">
            <div className="flex w-max animate-marquee">
                <Row />
                <Row ariaHidden />
            </div>
        </div>
    );
}
